import styled from 'styled-components'

export const Img = styled.img`
  width: 18rem;
  height: 25rem;
  object-fit: cover;
  border-radius: 0.5rem;
`
